var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-time__wrapper"},[_c('i',{staticClass:"fal fa-clock"}),(_vm.time && _vm.time.isValid())?_c('span',[_vm._v(" "+_vm._s(_vm.time.format(_vm.format))+" ")]):_c('span',[_vm._v(" N/A ")])])}
var staticRenderFns = []

export { render, staticRenderFns }